import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=e99a491c&scoped=true&lang=html&"
import script from "./AddButton.vue?vue&type=script&lang=js&"
export * from "./AddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99a491c",
  null
  
)

export default component.exports